import VueRouter from "vue-router";
import About from "./Components/About.vue";
import Home from "./Components/Home.vue";
import InstitutionsGrid from "./Components/InstitutionsGrid.vue";
import ProgramPerformance from "./Components/Program/Program.Performance.vue";
import ProgramScoreCard from "./Components/Program/Program.ScoreCard.vue";
import ProgramSummary from "./Components/Program/Program.Summary.vue";
import Program from "./Components/Program/Program.vue";
import StatePerformance from "./Components/StateReport/StateReport.Performance.vue";
import StateScoreCard from "./Components/StateReport/StateReport.ScoreCard.vue";
import StateSummary from "./Components/StateReport/StateReport.Summary.vue";
import StateReport from "./Components/StateReport/StateReport.vue";
import {
    store
} from "./Store.js";

const baseTitle = "Illinois Educator Preparation Profile";

export const router = new VueRouter({
    routes: [
        {
            name: "home",
            path: "/",
            scrollTop: true,
            component: Home,
            meta: {
                title: baseTitle
            }
        },
        {
            name: "institutions",
            path: "/institutions",
            scrollTop: true,
            component: InstitutionsGrid,
            meta: {
                title: `${baseTitle} - Institutions`
            }
        },
        {
            name: "stateReport",
            path: "/state-report",
            scrollTop: true,
            component: StateReport,
            meta: {
                title: `${baseTitle} - State Report`
            },
            children: [
                {
                    name: "stateSummary",
                    path: "",
                    component: StateSummary,
                    meta: {
                        title: `${baseTitle} - State Report Summary`
                    }
                },
                {
                    name: "stateScoreCard",
                    path: "performance/scorecard/:programId?",
                    component: StateScoreCard,
                    meta: {
                        title: `${baseTitle} - State Score Card`
                    }
                },
                {
                    name: "statePerformance",
                    path: "performance/:programId?",
                    component: StatePerformance,
                    meta: {
                        title: `${baseTitle} - State Performance`
                    }
                }
                
            ]
        },
        {
            name: "about",
            path: "/about",
            scrollTop: true,
            component: About,
            meta: {
                title: `${baseTitle} - About`
            }
        },
        {
            name: "program",
            path: "/institutions/:entityId/programs/",
            scrollTop: true,
            component: Program,
            children: [
                {
                    name: "programSummary",
                    path: ":programCategoryId",
                    component: ProgramSummary,
                    meta: {
                        title: `${baseTitle} - Program Summary`
                    }
                },
                {
                    name: "programPerformance",
                    path: ":programCategoryId/performance",
                    component: ProgramPerformance,
                    meta: {
                        title: `${baseTitle} - Program Performance`
                    }
                },
                {
                    name: "programScoreCard",
                    path: ":programCategoryId/performance/scorecard",
                    component: ProgramScoreCard,
                    meta: {
                        title: `${baseTitle} - Program Score Card`
                    }
                }
            ]
        }
    ]
});

function getTopScrollPoint() {
    let appHeader = document.querySelector("#app-header");
    let scrollTo = 0;
    if (appHeader) {
        if (window.pageYOffset >= appHeader.offsetHeight) scrollTo = appHeader.offsetHeight;
        else scrollTo = window.pageYOffset;
    }

    return scrollTo;
}

router.beforeEach((to, from, next) => {
    if (store.state.entityId > 0 && !to.params.entityId) store.dispatch("setEntityId", to.params.entityId);
    else if (to.params.entityId && store.state.entityId != to.params.entityId) store.dispatch("setEntityId", to.params.entityId);

    if (store.state.programId > 0 && !to.params.programId) store.dispatch("setProgramId", to.params.programId);
    else if (to.params.programId && store.state.programId != to.params.programId) store.dispatch("setProgramId", to.params.programId);

    if (store.state.programCategoryId > 0 && !to.params.programCategoryId) store.dispatch("setProgramCategoryId", to.params.programCategoryId);
    else if (to.params.programCategoryId && store.state.programCategoryId != to.params.programCategoryId) store.dispatch("setProgramCategoryId", to.params.programCategoryId);


    var p1 = to.matched.find(x => x.name === to.name);
    var p2 = from.matched.find(x => x.name === from.name);
    if (p1 && p1.parent && p1.parent.name && p2 && p2.parent && p2.parent.name && p1.parent.name === p2.parent.name && (!to.query || (!to.query.scrollTop)))
        finish();
    else {
        window.onscroll = isAtTop;
        if (window.pageYOffset !== getTopScrollPoint())
            window.scrollTo({
                top: getTopScrollPoint(),
                behavior: "smooth"
            });
        else
            finish();
    }


    function isAtTop() {
        if (window.pageYOffset === getTopScrollPoint()) {
            finish();
            window.onscroll = undefined;
        }
    }


    function finish() {
        let navBar = document.querySelector("#navbarSupportedContent");
        if (window.innerWidth <= 992 && navBar && navBar.classList.contains("show")) {
            $(navBar).collapse("hide");
            setTimeout(() => {
                setMeta();
                next();
            }, 350);
        }
        else {
            setMeta();
            next();
        }
    }

    function setMeta() {
        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
        document.title = nearestWithTitle ? nearestWithTitle.meta.title : baseTitle;
    }
});

export function smoothLeave(el) {
    document.body.style.overflowX = "hidden";
    el.parentElement.style.transition = "height 500ms ease-in-out";
    el.parentElement.style.height = el.offsetHeight + "px";
}


export function smoothEnter(el) {
    document.body.style.overflowX = "hidden";
    el.parentElement.style.transition = "height 500ms ease-in-out";
    el.parentElement.style.height = el.offsetHeight + "px";
}

export function smoothAfterEnter(el) {
    document.body.style.overflowX = "";
    el.parentElement.style.transition = "";
    el.parentElement.style.height = "";
}

export const enterCancelled = smoothAfterEnter;
export const leaveCancelled = smoothAfterEnter;